module.exports = __webpack_public_path__ + "img/5656.c81f892b.jpg";